module.exports = __webpack_public_path__ + "img/xingtansuo_act.6462822d.svg";